<template>
    <section class='add-rating-modal'>
        <b-modal :active="true" :canCancel="false">
            <section class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Slet udtalelse</p>
                </header>

                <section class="modal-card-body">
                    <p>Er du sikker på du vil slette udtalelsen?</p>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="close" type="button">{{$t('global.actions.cancel')}}</button>

                    <button class="button is-danger" @click="submit">{{$t('global.actions.delete')}}</button>
                </footer>
            </section>
        </b-modal>
    </section>
</template>

<style lang="scss" scoped>
    @import '../../../../../global/styles/variables';

    .preview {
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    }
</style>

<script>
    import RatingService from '@/taskflex/students/services/RatingService';

    export default {
        mounted() {
            this.loadCustomers();
        },

        props: {
            student: {
                type: Object,
                required: true,
            },

            rating: {
                type: Object,
                required: true,
            },
        },

        methods: {
            submit() {
                RatingService.remove(this.student.id, this.rating.id, {}, () => {
                    this.$emit('deleted');
                    this.close();
                });
            },

            close() {
                this.$emit('close');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/ratings/DeleteRatingModal.vue